import { createContext, useContext, useState } from "react";

const TestContext = createContext();

export const TestProvider = ({ children, initialTest }) => {
  const [selectedTest, setSelectedTest] = useState(initialTest || null);
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState(0);

  const [isPaused, setIsPaused] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  const resetTest = () => {
    setSelectedTest(null);
    setQuestions([]);
    setCurrentIndex(0);
    setAnswers({});
    setScore(0);
    setTimeLeft(0);
    setIsPaused(false);
  };

  return (
    <TestContext.Provider
      value={{
        selectedTest,
        setSelectedTest,
        questions,
        setQuestions,
        currentIndex,
        setCurrentIndex,
        answers,
        setAnswers,
        score,
        setScore,
        isPaused,
        setIsPaused,
        timeLeft,
        setTimeLeft,
        resetTest
      }}
    >
      {children}
    </TestContext.Provider>
  );
};

export const useTest = () => useContext(TestContext);
